var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-create',{attrs:{"model":_vm.model},scopedSlots:_vm._u([{key:"form",fn:function(ref){
var error = ref.error;
var submit = ref.submit;
return [_c('person-role-form',{attrs:{"error":error,"loading":false},on:{"submit":submit}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }